(ns opengb.i18n.m1p
  (:require [m1p.core :as m1p]
            [m1p.validation :as v]
            [opengb.i18n.format :as i18n.format]
            [opengb.i18n.macros]
            [taoensso.timbre :as timbre]))

(defn format-mf
  "Custom m1p function that wraps call to i18n.format/format-mf"
  [_opt params pattern]
  (i18n.format/format-mf pattern params))

(defn validate-dictionaries
  "Takes in a map of m1p dictionaries to validate and compare them to each
  other. Returns a formatted string of errors."
  [dictionaries]
  (->> (concat (v/find-unqualified-keys dictionaries)
               (v/find-missing-keys dictionaries)
               (v/find-misplaced-interpolations dictionaries)
               (v/find-type-discrepancies dictionaries)
               (v/find-interpolation-discrepancies dictionaries)
               (v/find-fn-get-param-discrepancies dictionaries))
       (v/format-report dictionaries)))

(defn prepare-dictionary
  "Takes in a translation dictionary for a single locale and returns a
  formatted dictionary that can be passed into m1p translate functions."
  [dictionary]
  (let [opts {:dictionary-fns {:opengb.i18n.m1p/format-mf format-mf}}]
    (-> dictionary
        (update-vals (partial vector :opengb.i18n.m1p/format-mf))
        (m1p/prepare-dictionary opts))))

(defn prepare-dictionaries
  "Takes in a map of dictionaries by locale and returns the map with the
  dictionaries formatted so they can be passed into m1p translate functions. An
  optional debug? flag will prints out a validation report if running in a dev
  environment."
  ([dictionaries]
   (prepare-dictionaries dictionaries false))
  ([dictionaries debug?]
   (let [prepared (update-vals dictionaries prepare-dictionary)]
     (when debug?
       (timbre/debug "\ni18n Dictionary Report"
                     "\n"
                     (validate-dictionaries prepared)))
     prepared)))

(defn translate
  "Takes in a map of m1p dictionaries keyed by locale, a locale, the key to
  translate, a map of params, and a flag to enable debug mode. If successful,
  returns the translated string. Otherwise returns the untranslated key as a
  string. Debug mode returns a map of the :input, an optional :translated-str
  (if successful), and an optional :error (if unsuccessful)."
  [dictionaries locale k params debug?]
  (let [params'        (merge {:opengb.i18n/locale locale} params)
        data           [locale k params']
        interpolated   (m1p/interpolate data {:dictionaries dictionaries})
        translated-str (when (string? interpolated) interpolated)
        error          (when (vector? interpolated) (str interpolated))]
    (if debug?
      {:error error :input data :translated-str translated-str}
      (or translated-str (str k)))))

(comment
  (let [sample-dictionary (opengb.i18n.macros/load-translations "sample-translations.csv")
        prepared-dicts (prepare-dictionaries sample-dictionary true)]
    (translate prepared-dicts :fr-CA :opengb.i18n/sample-welcome {} false)))
